import React from 'react';
import { cn } from '../../lib/utils';

export function ModeSwitcher({ modes, value, onChange, className }) {
  return (
    <div
      className={cn(
        'inline-flex flex-nowrap gap-1 rounded-full border border-slate-200 bg-slate-100/80 p-1',
        className
      )}
      role="tablist"
      aria-label="Funnel mode"
    >
      {modes.map((mode) => {
        const active = mode.id === value;
        return (
          <button
            key={mode.id}
            type="button"
            role="tab"
            aria-selected={active}
            title={mode.hint}
            onClick={() => onChange(mode.id)}
            className={cn(
              'rounded-full px-3.5 py-1.5 text-xs font-semibold transition-colors whitespace-nowrap',
              active
                ? 'bg-[var(--brand-primary,#1A428A)] text-white shadow-sm'
                : 'text-slate-600 hover:bg-white hover:text-slate-900'
            )}
          >
            {mode.label}
          </button>
        );
      })}
    </div>
  );
}
